import { render, staticRenderFns } from "./FuelAlertor.vue?vue&type=template&id=33263681&scoped=true"
import script from "./FuelAlertor.vue?vue&type=script&lang=js"
export * from "./FuelAlertor.vue?vue&type=script&lang=js"
import style0 from "./FuelAlertor.vue?vue&type=style&index=0&id=33263681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33263681",
  null
  
)

export default component.exports